<template>
    <div class="column is-4-desktop">
        <form>
            <!--<div class="field">-->
                <!--<label class="label">Payment terms</label>-->
                <!--<div class="control has-icons-left">-->
                    <!--<div class="select is-fullwidth" :class="{ 'is-loading': isLoading }">-->
                        <!--<select>-->
                            <!--<option disabled selected>Select Payment Terms</option>-->
                        <!--</select>-->
                    <!--</div>-->
                    <!--<span class="icon is-left">-->
                        <!--<i class="fas fa-file-invoice"></i>-->
                    <!--</span>-->
                <!--</div>-->
            <!--</div>-->
            <div class="field">
                <label class="label">Deposit Rate</label>
                <div class="control has-icons-left">
                    <div class="select is-fullwidth" :class="{ 'is-loading': isLoading }">
                        <select v-model="userData.deposit_rate" @change="updateUserSettings">
                            <option disabled selected>Select Deposit Rate</option>
                            <option value="1">JPY</option>
                            <option value="2">USD</option>
                        </select>
                    </div>
                    <span class="icon is-left">
                        <i class="fas fa-file-invoice-dollar"></i>
                    </span>
                </div>
            </div>
            <div class="field">
                <label class="label">Bidding Status</label>
                <div class="control has-icons-left">
                    <div class="select is-fullwidth" :class="{ 'is-loading': isLoading }">
                        <select v-model="userData.bidding" @change="updateUserSettings">
                            <option value="1">Enabled</option>
                            <option value="2">Disabled</option>
                        </select>
                    </div>
                    <span class="icon is-left">
                        <i class="fas fa-gavel"></i>
                    </span>
                </div>
            </div>
            <div class="field">
                <label class="label">Credit limit</label>
                <div class="control has-icons-left" :class="{ 'is-loading': isLoading }">
                    <input v-model="userData.credit_limit"
                           v-on:keyup="updateUserSettings"
                           class="input"
                           type="number"
                           placeholder="Enter credit limit">
                    <span class="icon is-small is-left">
                        <i class="fas fa-envelope"></i>
                    </span>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import apiUsers from './../../../../api/apiUsers'
    export default {
        props: ['user'],
        data() {
            return {
                isLoading: false,
                userData: {
                    user_id: this.$route.params.id,
                    deposit_rate: '',
                    bidding: '',
                    credit_limit: null
                }
            }
        },
        methods: {
            updateUserSettings() {
                this.isLoading = true;
                apiUsers
                    .userSettingsUpdateRequest(this.userData)
                    .then((response) => {
                        this.isLoading = false
                    })
                    .catch(error => console.log(error))
            }
        },
        created() {
            apiUsers
                .userRequest(this.$route.params.id)
                .then((response) => {
                    this.userData.deposit_rate = response.data.settings.deposit_rate
                    this.userData.bidding = response.data.settings.bidding
                })
                .catch(error => console.log(error))
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Users/User/Tabs/UserCredit.vue